module.exports = __webpack_public_path__ + "static/media/whiteLogo.cbb795d0.png";